import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/BreannaGlover_VanRensselaer_Pet/subs.vtt';
import poster from '@/static/assets/reviews/BreannaGlover_VanRensselaer_Pet/video.jpg';

export const BreannaGloverVanRensselaer: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Breanna',
  videoUrl: `${ASSETS_URL}/pet/BreannaGlover_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
